import { CurrencyPipe } from "@angular/common";
import { Pipe } from "@angular/core";
import { PipeTransform } from "@angular/core";

@Pipe({ name: "currencyPbmPipe" })
export class CurrencyPbmPipe implements PipeTransform {
  transform(value: number, currencyCode: string = "BRL", symbolDisplay?: boolean, digits?: string) {
    if (value) {
      const currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");
      const newValue: string = currencyPipe.transform(value, currencyCode, symbolDisplay, digits);
      return newValue;
    } else if (value === 0) {
      return "R$ 0,00";
    }
    return "-";
  }
}
